import { render, staticRenderFns } from "./PspCosteoRegistro.vue?vue&type=template&id=391d70d3"
import script from "./PspCosteoRegistro.vue?vue&type=script&lang=js"
export * from "./PspCosteoRegistro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports